import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useState } from 'react';
import { csrUserName, useCsrCustomerData } from 'components/csr/csrMode';
const container = css `
	margin-bottom: 57px;
`;
const banner = css `
	padding: 16px 8px;
	background-color: #555;
	color: white;
	border-bottom: solid 1px white;
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 999;
`;
function CsrBanner() {
    const [csrCustomerData, setCsrCustomerData] = useState(undefined);
    useCsrCustomerData(setCsrCustomerData);
    if (csrCustomerData) {
        return (_jsx("div", { css: container, children: _jsxs("div", { css: banner, children: ["You are in customer support mode. Signed in as:", ' ', csrUserName(csrCustomerData)] }) }));
    }
    return null;
}
export default CsrBanner;
